var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 340,
    viewBox: "0 0 340 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_3543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.324 -0.137695H93.6065V11.5803H105.324V-0.137695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 -0.137695H117.042V11.5803H128.76V-0.137695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 -0.137695H152.196V11.5803H163.914V-0.137695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 -0.137695H163.914V11.5803H175.632V-0.137695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 -0.137695H175.632V11.5803H187.35V-0.137695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 -0.137695H210.786V11.5803H222.504V-0.137695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 -0.137695H222.504V11.5803H234.222V-0.137695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 -0.137695H234.222V11.5803H245.94V-0.137695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 11.5801H93.6065V23.2981H105.324V11.5801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 11.5801H152.196V23.2981H163.914V11.5801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 11.5801H187.35V23.2981H199.068V11.5801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 11.5801H199.068V23.2981H210.786V11.5801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 11.5801H210.786V23.2981H222.504V11.5801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 23.2979H105.324V35.0158H117.042V23.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 23.2979H117.042V35.0158H128.76V23.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 23.2979H140.478V35.0158H152.196V23.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 23.2979H187.35V35.0158H199.068V23.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 23.2979H234.222V35.0158H245.94V23.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 35.0166H93.6065V46.7346H105.324V35.0166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 35.0166H105.324V46.7346H117.042V35.0166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 35.0166H117.042V46.7346H128.76V35.0166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 35.0166H163.914V46.7346H175.632V35.0166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 35.0166H175.632V46.7346H187.35V35.0166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 35.0166H199.068V46.7346H210.786V35.0166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 35.0166H222.504V46.7346H234.222V35.0166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 46.7344H105.324V58.4524H117.042V46.7344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 46.7344H163.914V58.4524H175.632V46.7344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 46.7344H187.35V58.4524H199.068V46.7344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 46.7344H222.504V58.4524H234.222V46.7344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 46.7344H234.222V58.4524H245.94V46.7344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 58.4521H128.76V70.1701H140.478V58.4521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 58.4521H152.196V70.1701H163.914V58.4521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 58.4521H175.632V70.1701H187.35V58.4521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 58.4521H187.35V70.1701H199.068V58.4521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 58.4521H199.068V70.1701H210.786V58.4521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 58.4521H210.786V70.1701H222.504V58.4521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 58.4521H222.504V70.1701H234.222V58.4521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 70.1699H93.6065V81.8879H105.324V70.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 70.1699H117.042V81.8879H128.76V70.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 70.1699H140.478V81.8879H152.196V70.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 70.1699H163.914V81.8879H175.632V70.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 70.1699H187.35V81.8879H199.068V70.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 70.1699H210.786V81.8879H222.504V70.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 70.1699H234.222V81.8879H245.94V70.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 81.8877H93.6065V93.6057H105.324V81.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 81.8877H117.042V93.6057H128.76V81.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 81.8877H128.76V93.6057H140.478V81.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 81.8877H175.632V93.6057H187.35V81.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 81.8877H187.35V93.6057H199.068V81.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 81.8877H199.068V93.6057H210.786V81.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 81.8877H210.786V93.6057H222.504V81.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 81.8877H234.222V93.6057H245.94V81.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 93.6064H-0.137375V105.324H11.5806V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0166 93.6064H23.2986V105.324H35.0166V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 93.6064H35.0166V105.324H46.7346V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 93.6064H58.4525V105.324H70.1705V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8885 93.6064H70.1705V105.324H81.8885V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6065 93.6064H81.8885V105.324H93.6065V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 93.6064H105.324V105.324H117.042V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 93.6064H117.042V105.324H128.76V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 93.6064H128.76V105.324H140.478V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 93.6064H140.478V105.324H152.196V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 93.6064H152.196V105.324H163.914V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 93.6064H175.632V105.324H187.35V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 93.6064H199.068V105.324H210.786V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 93.6064H210.786V105.324H222.504V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 93.6064H222.504V105.324H234.222V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 93.6064H234.222V105.324H245.94V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 93.6064H257.658V105.324H269.376V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 93.6064H292.812V105.324H304.53V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 93.6064H316.248V105.324H327.966V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.684 93.6064H327.966V105.324H339.684V93.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 105.324H-0.137375V117.042H11.5806V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0166 105.324H23.2986V117.042H35.0166V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 105.324H46.7345V117.042H58.4525V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6065 105.324H81.8885V117.042H93.6065V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 105.324H93.6065V117.042H105.324V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 105.324H117.042V117.042H128.76V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 105.324H140.478V117.042H152.196V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 105.324H152.196V117.042H163.914V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 105.324H163.914V117.042H175.632V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 105.324H175.632V117.042H187.35V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 105.324H222.504V117.042H234.222V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 105.324H234.222V117.042H245.94V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.658 105.324H245.94V117.042H257.658V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 105.324H257.658V117.042H269.376V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 105.324H269.376V117.042H281.094V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 105.324H281.094V117.042H292.812V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.684 105.324H327.966V117.042H339.684V105.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2986 117.042H11.5806V128.76H23.2986V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0166 117.042H23.2986V128.76H35.0166V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 117.042H46.7345V128.76H58.4525V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 117.042H58.4525V128.76H70.1705V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8885 117.042H70.1705V128.76H81.8885V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6065 117.042H81.8885V128.76H93.6065V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 117.042H93.6065V128.76H105.324V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 117.042H105.324V128.76H117.042V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 117.042H152.196V128.76H163.914V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 117.042H187.35V128.76H199.068V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 117.042H210.786V128.76H222.504V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 117.042H234.222V128.76H245.94V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 117.042H269.376V128.76H281.094V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 117.042H281.094V128.76H292.812V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 117.042H304.53V128.76H316.248V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 117.042H316.248V128.76H327.966V117.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 128.76H-0.137375V140.478H11.5806V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0166 128.76H23.2986V140.478H35.0166V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 128.76H58.4525V140.478H70.1705V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6065 128.76H81.8885V140.478H93.6065V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 128.76H117.042V140.478H128.76V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 128.76H187.35V140.478H199.068V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 128.76H210.786V140.478H222.504V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 128.76H222.504V140.478H234.222V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.658 128.76H245.94V140.478H257.658V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 128.76H257.658V140.478H269.376V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 128.76H269.376V140.478H281.094V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 128.76H281.094V140.478H292.812V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.684 128.76H327.966V140.478H339.684V128.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 140.479H-0.137375V152.196H11.5806V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0166 140.479H23.2986V152.196H35.0166V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 140.479H35.0166V152.196H46.7346V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 140.479H46.7345V152.196H58.4525V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 140.479H58.4525V152.196H70.1705V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8885 140.479H70.1705V152.196H81.8885V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 140.479H117.042V152.196H128.76V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 140.479H163.914V152.196H175.632V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 140.479H175.632V152.196H187.35V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 140.479H199.068V152.196H210.786V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 140.479H234.222V152.196H245.94V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 140.479H292.812V152.196H304.53V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 140.479H304.53V152.196H316.248V140.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 152.196H-0.137375V163.914H11.5806V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2986 152.196H11.5806V163.914H23.2986V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0166 152.196H23.2986V163.914H35.0166V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 152.196H35.0166V163.914H46.7346V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 152.196H46.7345V163.914H58.4525V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 152.196H58.4525V163.914H70.1705V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 152.196H117.042V163.914H128.76V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 152.196H163.914V163.914H175.632V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 152.196H187.35V163.914H199.068V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 152.196H222.504V163.914H234.222V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 152.196H257.658V163.914H269.376V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 152.196H269.376V163.914H281.094V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 152.196H304.53V163.914H316.248V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 152.196H316.248V163.914H327.966V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.684 152.196H327.966V163.914H339.684V152.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 163.914H-0.137375V175.632H11.5806V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 163.914H35.0166V175.632H46.7346V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8885 163.914H70.1705V175.632H81.8885V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6065 163.914H81.8885V175.632H93.6065V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 163.914H93.6065V175.632H105.324V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 163.914H128.76V175.632H140.478V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 163.914H140.478V175.632H152.196V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 163.914H152.196V175.632H163.914V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 163.914H175.632V175.632H187.35V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 163.914H187.35V175.632H199.068V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 163.914H199.068V175.632H210.786V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 163.914H210.786V175.632H222.504V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 163.914H222.504V175.632H234.222V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 163.914H234.222V175.632H245.94V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.658 163.914H245.94V175.632H257.658V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 163.914H257.658V175.632H269.376V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 163.914H269.376V175.632H281.094V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 163.914H281.094V175.632H292.812V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 163.914H304.53V175.632H316.248V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 163.914H316.248V175.632H327.966V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.684 163.914H327.966V175.632H339.684V163.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 175.632H-0.137375V187.35H11.5806V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0166 175.632H23.2986V187.35H35.0166V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 175.632H35.0166V187.35H46.7346V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 175.632H46.7345V187.35H58.4525V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 175.632H117.042V187.35H128.76V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 175.632H128.76V187.35H140.478V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 175.632H163.914V187.35H175.632V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 175.632H187.35V187.35H199.068V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 175.632H210.786V187.35H222.504V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.658 175.632H245.94V187.35H257.658V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 175.632H269.376V187.35H281.094V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 175.632H281.094V187.35H292.812V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 175.632H316.248V187.35H327.966V175.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 187.35H-0.137375V199.068H11.5806V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 187.35H35.0166V199.068H46.7346V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 187.35H58.4525V199.068H70.1705V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8885 187.35H70.1705V199.068H81.8885V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 187.35H93.6065V199.068H105.324V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 187.35H140.478V199.068H152.196V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 187.35H163.914V199.068H175.632V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 187.35H175.632V199.068H187.35V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 187.35H187.35V199.068H199.068V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 187.35H210.786V199.068H222.504V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 187.35H234.222V199.068H245.94V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.658 187.35H245.94V199.068H257.658V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 187.35H281.094V199.068H292.812V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 187.35H292.812V199.068H304.53V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 187.35H316.248V199.068H327.966V187.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2986 199.068H11.5806V210.786H23.2986V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0166 199.068H23.2986V210.786H35.0166V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 199.068H46.7345V210.786H58.4525V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 199.068H58.4525V210.786H70.1705V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6065 199.068H81.8885V210.786H93.6065V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 199.068H117.042V210.786H128.76V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 199.068H163.914V210.786H175.632V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 199.068H187.35V210.786H199.068V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 199.068H199.068V210.786H210.786V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 199.068H234.222V210.786H245.94V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.658 199.068H245.94V210.786H257.658V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 199.068H269.376V210.786H281.094V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 199.068H292.812V210.786H304.53V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 199.068H304.53V210.786H316.248V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 199.068H316.248V210.786H327.966V199.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5806 210.786H-0.137375V222.504H11.5806V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 210.786H58.4525V222.504H70.1705V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8885 210.786H70.1705V222.504H81.8885V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6065 210.786H81.8885V222.504H93.6065V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 210.786H93.6065V222.504H105.324V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 210.786H105.324V222.504H117.042V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 210.786H128.76V222.504H140.478V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 210.786H152.196V222.504H163.914V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 210.786H163.914V222.504H175.632V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 210.786H175.632V222.504H187.35V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 210.786H187.35V222.504H199.068V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 210.786H269.376V222.504H281.094V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 210.786H304.53V222.504H316.248V210.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 222.504H35.0166V234.222H46.7346V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 222.504H46.7345V234.222H58.4525V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 222.504H58.4525V234.222H70.1705V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6065 222.504H81.8885V234.222H93.6065V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 222.504H105.324V234.222H117.042V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 222.504H140.478V234.222H152.196V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 222.504H152.196V234.222H163.914V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 222.504H163.914V234.222H175.632V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 222.504H199.068V234.222H210.786V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 222.504H222.504V234.222H234.222V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 222.504H257.658V234.222H269.376V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 222.504H304.53V234.222H316.248V222.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2986 234.222H11.5806V245.94H23.2986V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 234.222H35.0166V245.94H46.7346V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1705 234.222H58.4525V245.94H70.1705V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8885 234.222H70.1705V245.94H81.8885V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6065 234.222H81.8885V245.94H93.6065V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 234.222H105.324V245.94H117.042V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 234.222H117.042V245.94H128.76V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 234.222H128.76V245.94H140.478V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 234.222H140.478V245.94H152.196V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 234.222H152.196V245.94H163.914V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 234.222H163.914V245.94H175.632V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 234.222H187.35V245.94H199.068V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 234.222H199.068V245.94H210.786V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 234.222H210.786V245.94H222.504V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 234.222H234.222V245.94H245.94V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.658 234.222H245.94V245.94H257.658V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 234.222H257.658V245.94H269.376V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 234.222H269.376V245.94H281.094V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 234.222H281.094V245.94H292.812V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 234.222H292.812V245.94H304.53V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 234.222H304.53V245.94H316.248V234.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 245.939H93.6065V257.657H105.324V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 245.939H117.042V257.657H128.76V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 245.939H175.632V257.657H187.35V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 245.939H187.35V257.657H199.068V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 245.939H199.068V257.657H210.786V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 245.939H210.786V257.657H222.504V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 245.939H234.222V257.657H245.94V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 245.939H281.094V257.657H292.812V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 245.939H292.812V257.657H304.53V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 245.939H304.53V257.657H316.248V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 245.939H316.248V257.657H327.966V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.684 245.939H327.966V257.657H339.684V245.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 257.658H93.6065V269.376H105.324V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 257.658H163.914V269.376H175.632V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 257.658H175.632V269.376H187.35V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 257.658H210.786V269.376H222.504V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 257.658H222.504V269.376H234.222V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 257.658H234.222V269.376H245.94V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 257.658H257.658V269.376H269.376V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 257.658H281.094V269.376H292.812V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 257.658H292.812V269.376H304.53V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 257.658H316.248V269.376H327.966V257.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 269.376H93.6065V281.094H105.324V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 269.376H117.042V281.094H128.76V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 269.376H128.76V281.094H140.478V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 269.376H152.196V281.094H163.914V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 269.376H163.914V281.094H175.632V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 269.376H175.632V281.094H187.35V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 269.376H210.786V281.094H222.504V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 269.376H222.504V281.094H234.222V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 269.376H234.222V281.094H245.94V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 269.376H281.094V281.094H292.812V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 269.376H292.812V281.094H304.53V269.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 281.094H105.324V292.812H117.042V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 281.094H117.042V292.812H128.76V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 281.094H128.76V292.812H140.478V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 281.094H199.068V292.812H210.786V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 281.094H234.222V292.812H245.94V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.658 281.094H245.94V292.812H257.658V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 281.094H257.658V292.812H269.376V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 281.094H269.376V292.812H281.094V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 281.094H281.094V292.812H292.812V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 281.094H304.53V292.812H316.248V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.684 281.094H327.966V292.812H339.684V281.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 292.812H93.6065V304.53H105.324V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 292.812H105.324V304.53H117.042V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 292.812H117.042V304.53H128.76V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.478 292.812H128.76V304.53H140.478V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 292.812H140.478V304.53H152.196V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 292.812H152.196V304.53H163.914V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.786 292.812H199.068V304.53H210.786V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 292.812H234.222V304.53H245.94V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.812 292.812H281.094V304.53H292.812V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 292.812H292.812V304.53H304.53V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 292.812H316.248V304.53H327.966V292.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 304.529H93.6065V316.247H105.324V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 304.529H105.324V316.247H117.042V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 304.529H140.478V316.247H152.196V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 304.529H152.196V316.247H163.914V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 304.529H187.35V316.247H199.068V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 304.529H222.504V316.247H234.222V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 304.529H234.222V316.247H245.94V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 304.529H269.376V316.247H281.094V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 304.529H304.53V316.247H316.248V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.684 304.529H327.966V316.247H339.684V304.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 316.248H105.324V327.966H117.042V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.914 316.248H152.196V327.966H163.914V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.632 316.248H163.914V327.966H175.632V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 316.248H175.632V327.966H187.35V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.068 316.248H187.35V327.966H199.068V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 316.248H222.504V327.966H234.222V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 316.248H234.222V327.966H245.94V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.376 316.248H257.658V327.966H269.376V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.094 316.248H269.376V327.966H281.094V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 316.248H292.812V327.966H304.53V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 316.248H316.248V327.966H327.966V316.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 327.966H93.6065V339.684H105.324V327.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.042 327.966H105.324V339.684H117.042V327.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.196 327.966H140.478V339.684H152.196V327.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.504 327.966H210.786V339.684H222.504V327.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.222 327.966H222.504V339.684H234.222V327.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94 327.966H234.222V339.684H245.94V327.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.658 327.966H245.94V339.684H257.658V327.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53 327.966H292.812V339.684H304.53V327.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.966 327.966H316.248V339.684H327.966V327.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5846 -0.137695H12.1665H-0.137375V12.1662V69.5843V81.8882H12.1665H69.5846H81.8885V69.5843V12.1662V-0.137695H69.5846ZM69.5846 69.5843H12.1665V12.1662H69.5846V69.5843Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.38 -0.137695H269.962H257.658V12.1662V69.5843V81.8882H269.962H327.38H339.684V69.5843V12.1662V-0.137695H327.38ZM327.38 69.5843H269.962V12.1662H327.38V69.5843Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5846 257.658H12.1665H-0.137375V269.962V327.38V339.684H12.1665H69.5846H81.8885V327.38V269.962V257.658H69.5846ZM69.5846 327.38H12.1665V269.962H69.5846V327.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 23.2979H23.2986V58.4518H58.4525V23.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.248 23.2979H281.094V58.4518H316.248V23.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 281.094H23.2986V316.248H58.4525V281.094Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_3543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 340,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.b3808dee1fadc7381575601e623459f5.svg";
export { ForwardRef as ReactComponent };